var map = {
	"./Lavender_Logo_RGB.png": "abc5",
	"./Lavender_Logo_RGB1.jpeg": "d0f2",
	"./back.jpg": "e857",
	"./back.png": "ae5c",
	"./bg.jpg": "3625",
	"./lb_logo2.png": "06a1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";